// ========== Imports ==========
import { dateFormat } from 'helpers/StringNumberFunction/formatDate';
import { amtStr } from 'helpers/StringNumberFunction/numFormatter';

// ========== Component ==========
export const ELetterServiceCosting = ({
  docType,
  previewDetail,
  allpreviewDetail,
  getCompany,
  getJournalEntry,
  paramVal,
  getGlCostCentre,
  getGlMasterCOA,
  approvalLog,
}) => {
  const getCostCentreDetails = costCentreID => {
    if (!costCentreID || !getGlCostCentre || getGlCostCentre.length === 0) {
      return { code: '-', name: '-' };
    }

    const costCentre = getGlCostCentre.find(cc => cc.ID === costCentreID);
    return {
      code: costCentre?.Code || '-',
      name: costCentre?.Name || '-',
    };
  };

  const getMasterCOADetails = masterCOAID => {
    if (!masterCOAID || !getGlMasterCOA || getGlMasterCOA.length === 0) {
      return { code: '-', name: '-' };
    }

    const masterCOA = getGlMasterCOA.find(coa => coa.ID === masterCOAID);
    return {
      code: masterCOA?.Code || '-',
      name: masterCOA?.Name || '-',
    };
  };

  const journalEntry =
    getJournalEntry && getJournalEntry.length > 0
      ? getJournalEntry[0] // If it's an array with data, use first item
      : previewDetail; // Otherwise use previewDetail

  const detailItems = journalEntry?.costAdjustmentDetail || [];

  let approverNameL1 = '';
  let approvalDateL1 = '';
  let roleNameL1 = '';
  let approverNameL2 = '';
  let approvalDateL2 = '';
  let roleNameL2 = '';
  let approverNameL3 = '';
  let approvalDateL3 = '';
  let roleNameL3 = '';
  let approverNameL4 = '';
  let approvalDateL4 = '';
  let roleNameL4 = '';
  let approverNameL5 = '';
  let approvalDateL5 = '';
  let roleNameL5 = '';

  if (approvalLog && approvalLog.length > 0) {
    const completedWorkflow = approvalLog.find(
      wf => wf.workFlowStatus === 'COMPLETED',
    );

    if (completedWorkflow?.workflowStep) {
      // Filter only approved steps and sort by stepNo
      const approvedSteps = completedWorkflow.workflowStep
        .filter(step => step.approvalStatus === 'APPROVED')
        .sort((a, b) => a.stepNo - b.stepNo);

      approvedSteps.forEach(step => {
        if (step.stepNo === 1) {
          approverNameL1 = step.name || '';
          approvalDateL1 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL1 = step.roleName || '';
        } else if (step.stepNo === 2) {
          approverNameL2 = step.name || '';
          approvalDateL2 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL2 = step.roleName || '';
        } else if (step.stepNo === 3) {
          approverNameL3 = step.name || '';
          approvalDateL3 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL3 = step.roleName || '';
        } else if (step.stepNo === 4) {
          approverNameL4 = step.name || '';
          approvalDateL4 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL4 = step.roleName || '';
        } else if (step.stepNo === 5) {
          approverNameL5 = step.name || '';
          approvalDateL5 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL5 = step.roleName || '';
        }
      });
    }
  }

  console.log('=== ELetterServiceCosting Debug ===');
  console.log('journalEntry:', journalEntry);
  console.log('detailItems:', detailItems);

  // ========== Document Type Processing ==========
  switch (docType) {
    case 'journal-entry':
      const result = Object.assign(paramVal, {
        // ==========================
        // COMPANY DETAILS
        // ==========================
        '[companyName]': getCompany?.[0]?.Name || '',
        '[companyRegNo]': getCompany?.[0]?.CompanyRegNo || '',
        '[companyAddress]': getCompany?.[0]?.Address?.address || '',
        '[companyContactNo]': getCompany?.[0]?.ContactNo || '',

        // ==========================
        // DOCUMENT DETAILS
        // ==========================
        '[docNo]': journalEntry?.docNo || '',
        '[docRef]': journalEntry?.docRef || '',
        '[description]': journalEntry?.description || '',
        '[docDate]': journalEntry?.docDate
          ? dateFormat(journalEntry.docDate)
          : '',
        '[transactionDate]': journalEntry?.transactionDate
          ? dateFormat(journalEntry.transactionDate)
          : '',
        '[docAmt]':
          journalEntry?.docAmt != null ? amtStr(journalEntry.docAmt) : '0.00',

        // ==========================
        // AUDIT/APPROVAL DETAILS
        // ==========================
        '[createdDate]':
          journalEntry?.auditLog?.createdTs ?? journalEntry?.createdTs
            ? dateFormat(
                journalEntry.auditLog.createdTs ?? journalEntry?.createdTs,
              )
            : '',
        '[preparedBy]': journalEntry?.auditLog?.createdName || '',
        // '[approvedBy]': journalEntry?.auditLog?.modName || '',
        // '[approvedDate]':
        //   journalEntry?.auditLog?.modTs ?? journalEntry?.modTs
        //     ? dateFormat(journalEntry.auditLog.modTs ?? journalEntry?.modTs)
        //     : '',
        '[approverNameL1]': approverNameL1,
        '[approvalDateL1]': approvalDateL1,
        '[roleNameL1]': roleNameL1,
        '[approverNameL2]': approverNameL2,
        '[approvalDateL2]': approvalDateL2,
        '[roleNameL2]': roleNameL2,
        '[approverNameL3]': approverNameL3,
        '[approvalDateL3]': approvalDateL3,
        '[roleNameL3]': roleNameL3,
        '[approverNameL4]': approverNameL4,
        '[approvalDateL4]': approvalDateL4,
        '[roleNameL4]': roleNameL4,
        '[approverNameL5]': approverNameL5,
        '[approvalDateL5]': approvalDateL5,
        '[roleNameL5]': roleNameL5,

        // ==========================
        // DETAIL LINE ITEMS
        // ==========================
        items:
          detailItems?.map((el, i) => {
            const indexValue = i + 1;

            // Get the cost centre details using the costCentreID
            const costCentreDetails = getCostCentreDetails(el?.costCentreID);
            const masterCOADetails = getMasterCOADetails(el?.masterCOAID);

            const isProject = el?.accountType == 'PROJECT' ? 'Y' : '';
            const isGL = el?.accountType == 'GENERAL_LEDGER' ? 'Y' : '';

            return {
              '[index]': indexValue,

              // Project Data
              '[contractTitle]': isProject ? el?.contract?.title || '-' : '-',
              '[wbsName]': isProject
                ? el?.wbs
                  ? el.wbs.parentName
                    ? `${el.wbs.parentName} / ${el.wbs.name}`
                    : el.wbs.name
                  : '-'
                : '-',
              '[costCategory]': isProject ? el?.costCategory?.name || '-' : '-',
              '[itemName]': isProject ? el?.costItem?.name || '-' : '-',
              '[revenueCategory]': isProject
                ? el?.revenueCategory?.name || '-'
                : '-',

              // General Ledger Data
              '[glAccountCode]': isGL ? masterCOADetails?.code : '-',
              '[glAccountName]': isGL ? masterCOADetails?.name : '-',
              '[departmentCode]': isGL ? costCentreDetails.code : '-',
              '[departmentCodeName]': isGL ? costCentreDetails.name : '-',

              '[debitAmt]': el?.docAmt > 0 ? amtStr(el.docAmt) : '0.00',
              '[creditAmt]': el?.docAmt < 0 ? amtStr(el.docAmt * -1) : '0.00',
              '[remarks]': el?.remarks || '',
              '[accountType]': el?.accountType,
            };
          }) || [],

        '[sumDebitAmt]':
          journalEntry?.debitAmt != null
            ? amtStr(journalEntry.debitAmt)
            : '0.00',
        '[sumCreditAmt]':
          journalEntry?.creditAmt != null
            ? amtStr(journalEntry.creditAmt * -1)
            : '0.00',
      });
  }
};
